<script>
export default {
  name: "TcnHeader",
  components: {},
  props: {
    value: {default: null},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  render(createElement) {
    const child = createElement("div", {
      domProps: {innerHTML: 'x-content' in this.schema ? this.schema['x-content'] : "Brak dyrektywy x-content w schema"},
      class: 'x-style' in this.schema ? this.schema['x-content-class'] : ""
    });

    const headerSize = () => {
      switch (this.schema['header-size']) {
        case 1:
          return "h1"
        case 2:
          return "h2"
        case 3:
          return "h3"
        case 4:
          return "h4"
        case 5:
          return "h5"
        case 6:
          return "h6"
        default:
          return "h3"
      }
    }

    return createElement(headerSize(), {}, [child])
  }
}
</script>

<style scoped lang="css">

</style>
